import { NodeViewContent, NodeViewWrapper, useEditorState } from "@tiptap/react";
import { observer } from "mobx-react-lite";

import { useStore } from "@/store";
import { twMerge } from "@/utils/twMerge";

import { ChangeRequestWidget } from "./ChangeRequestWidget";
import { getParentChangeRequest } from "./helpers";
import { useChangeRequestPending } from "./useChangeRequestPending";

import type { NodeViewProps } from "@tiptap/react";

export const ChangeRequestPartAfterView = observer(function ChangeRequestPartAfterView({
  editor,
  getPos,
}: NodeViewProps) {
  const parent = useEditorState({
    editor,
    selector: () => getParentChangeRequest(editor, getPos),
  });
  const changeRequestId = parent?.changeRequestId;
  const author = parent?.author;
  const pending = useChangeRequestPending(parent?.pendingAt);
  const { chats } = useStore();
  const shouldAnimateBorder = pending || (chats?.isBotGeneratingForCurrentDoc ?? false);

  return (
    <NodeViewWrapper
      data-change-request-part="after"
      className="relative z-10 text-gray-950 dark:text-gray-50"
    >
      <svg
        aria-hidden
        className={twMerge(
          "pointer-events-none absolute top-[-6px] bottom-[-6px] left-[25px] -right-2 h-[calc(100%+12px)] w-[calc(100%-25px+8px)]",
          "sm:-left-[6px] sm:-right-[6px] sm:w-[calc(100%+12px)]",
        )}
      >
        <rect
          x="0.6"
          y="0.6"
          width="calc(100% - 1.2px)"
          height="calc(100% - 1.2px)"
          rx="10"
          ry="10"
          fill="none"
          className={twMerge(
            "stroke-green-500 dark:stroke-green-600",
            shouldAnimateBorder && "motion-safe:animate-change-request-border",
          )}
          strokeWidth="1.2"
          strokeDasharray="8 8"
          strokeDashoffset="4"
        />
      </svg>
      <NodeViewContent />
      <ChangeRequestWidget
        author={author}
        pending={pending}
        onReject={() => {
          if (changeRequestId) {
            editor.chain().rejectChangeRequest(changeRequestId).run();
          }
        }}
        onApprove={() => {
          if (changeRequestId) {
            editor.chain().approveChangeRequest(changeRequestId).run();
          }
        }}
      />
    </NodeViewWrapper>
  );
});
